import Typography from '@mui/material/Typography';
// import { useState } from 'react';
import Tower from './Tower';

function TowersListContainer({ setHighlightMarker, map, data, searchMarker }) {
    // const [iconActive, setIconActive] = useState(false);

    const handleHoverEvent = (e) => {
        if (e.type === 'mouseenter') {
            e.currentTarget.style.animation = 'glowCard 1s ease-in-out alternate infinite'
            let lat = e.currentTarget.getAttribute("data-latitude");
            let lon = e.currentTarget.getAttribute("data-longitude");
            if (lat && lon) setHighlightMarker([lat, lon]);
        } else {
            setHighlightMarker(null);
            //if (!iconActive) setHighlightMarker(null);
            e.currentTarget.style.animation = 'none'
        }
    }

    const handleClickEvent = (e) => {
        if (e.target.nodeName !== 'A') {
            let lat = e.currentTarget.getAttribute("data-latitude");
            let lon = e.currentTarget.getAttribute("data-longitude");
            map.flyTo([lat, lon]);
            setHighlightMarker([lat, lon]);
            // setIconActive(true);
            // setTimeout(() => {
            //     setIconActive(false);
            //     setHighlightMarker(null);
            // }, "5000");
        }
    }

    const filteredCount = data.filter((obj) => obj.properties.isFiltered === true).length;

    return (
        <>
            {data.length > 0 ?
                filteredCount > 0 ?
                    <Typography sx={{px:'5px'}}>Showing {data.length - filteredCount} of {data.length} towers</Typography>
                    :
                    <Typography sx={{px:'5px'}}>Showing {data.length} towers</Typography>
                :
                <>
                <Typography sx={{py: '5px', px:'5px'}} variant="h5">No Results</Typography>
                <Typography sx={{py: '10px', px:'5px'}} variant="body2">Try removing filters or zoom out on the map to search a larger area.</Typography>
                </>
            }
            {data.map((tower, index) => <Tower searchMarker={searchMarker} handleClickEvent={handleClickEvent} handleHoverEvent={handleHoverEvent} key={index} {...tower} />)}
        </>
    );
}

export default TowersListContainer;